<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card
          header="Customer Report"
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group label-cols-sm="3" class="mb-0">
                <b-input-group>
                  <b-input-group-append>
                    <download-excel
                      :fetch="downloadReport"
                      :fields="exportFields"
                      :before-generate="startDownload"
                      :before-finish="finishDownload"
                      :type="'csv'"
                      :name="`CustomerReport_${Date.now()}.csv`"
                    >
                      <eb-button
                        classic="mr-1 btn-primary"
                        text="Download Report"
                        :disabled="false"
                      ></eb-button>
                    </download-excel>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import { exportFields } from "@/shared/constants/customer";
export default {
  name: "customer",
  components: {
    ebButton
  },
  data: () => {
    return {
      customerData: [],
      exportFields: exportFields,
      isLoader: false,
      totalCount: 0
    };
  },
  methods: {
    async downloadReport() {
      let data = [];
      let loop = async page => {
       await this.$store
          .dispatch("customer/fetchCustomerExport", {
            page: page,
            limit: 500
          })
          .then(res => {
            if (res.status === 1) {
              this.totalCount = res.meta.total;
              Array.prototype.push.apply(data,res.response);
              if (data.length < this.totalCount ) {
                loop(Number(res.meta.currentPage) + 1);
              }
              else {
                let array = this.getProcessedJson(data, exportFields);
                this.exportAsCSV(array,'customers')
                this.finishDownload();
              }
            }
          });
      };
      loop(1);
      if(data.length !== 0){
        return data;
      }
    },
    getProcessedJson(data, header) {
      let keys = this.getKeys(data, header);
      let newData = [];
      let _self = this;
      data.map(function(item, index) {
        let newItem = {};
        for (let label in keys) {
          let property = keys[label];
          newItem[label] = _self.getValue(property, item);
        }
        newData.push(newItem);
      });
      return newData;
    },
    getValue(key, item) {
      const field = typeof key !== "object" ? key : key.field;
      let indexes = typeof field !== "string" ? [] : field.split(".");
      let value = this.defaultValue;
      if (!field) value = item;
      else if (indexes.length > 1)
        value = this.getValueFromNestedItem(item, indexes);
      else value = this.parseValue(item[field]);
      if (key.hasOwnProperty("callback"))
        value = this.getValueFromCallback(value, key.callback);
      return value;
    },
    getKeys(data, header) {
      if (header) {
        return header;
      }
      let keys = {};
      for (let key in data[0]) {
        keys[key] = key;
      }
      return keys;
    },

    getValueFromCallback(item, callback) {
      if (typeof callback !== "function") return this.defaultValue;
      const value = callback(item);
      return this.parseValue(value);
    },
    getValueFromNestedItem(item, indexes) {
      let nestedItem = item;
      for (let index of indexes) {
        if (nestedItem) nestedItem = nestedItem[index];
      }
      return this.parseValue(nestedItem);
    },
    parseValue(value) {
      return value || value === 0 || typeof value === "boolean" ? value : "";
    },
    startDownload() {
      this.$toasted.info("Downloading..");
    },
    finishDownload() {
      this.$toasted.clear();
    }
  }
};
</script>
<style scoped>
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}
</style>
